import styled from 'styled-components';

export const SlideImage = styled.img`
  width: 100%;
  height: 24rem;
`;

export const SwiperContainer = styled.div`
  .swiper-pagination-bullet {
    background: white;
  }
`;
